<div class="text-center pt-5">
	<h2 class="text-danger">🚫 Access Denied</h2>
	<p class="lead">Your account has been <strong>suspended</strong>.</p>
</div>
